import { CustomerGroupsApiService } from '../../common/services/customer-groups.api.service';
import REQUEST_STATUS from '../../common/enums/requestStatus';

export default {
  namespaced: true,

  state: {
    status: REQUEST_STATUS.LOADING,
    items: [],
  },

  getters: {
    getAllCustomerGroups: state => state.items,
    getStatus: state => state.status,
    getCustomerGroup: state => id => state.items.find(item => item.id === id),
  },

  mutations: {
    SET_ITEMS(state, data) {
      state.items = data;
    },
    FETCH_REQUEST(state) {
      state.status = REQUEST_STATUS.LOADING;
    },
    FETCH_SUCCESS(state) {
      state.status = REQUEST_STATUS.SUCCESS;
    },
    FETCH_FAIL(state) {
      state.status = REQUEST_STATUS.FAIL;
    },
  },

  actions: {
    fetchAllCustomerGroups({ commit, dispatch }, { options }) {
      commit('FETCH_REQUEST');

      return CustomerGroupsApiService.getAll(builder => {
        if (options && options.pagination === false) {
          builder.turnOffPagination();
        }
      })
        .then(response => {
          commit('SET_ITEMS', response.getItems());
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    handleError({ commit }, response) {
      commit('FETCH_FAIL');
      const message = response.getFirstValidationErrorMessage() || response.getMessage();
      this.$app.$alertError(message);
    },
  },
};
